var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-13
 * @brief SEI 운영관리 - SiteInfo 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { curAdminTreeState } from "../../../../recoil/assessmentState";
import { reLoadPage } from "../../../../recoil/userState";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingBoxState } from "../../../../recoil/menuState";
import { userInfoLoginState } from "../../../../recoil/userState"; // recoil
// utils
import { useAsync } from "react-async";
import { alertState } from "../../../../recoil/assessmentState";
import { langId } from "../../../../recoil/langState";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import { useTrans } from "../../../../utils/langs/useTrans";
import EhpPagination from "../../../common/pagination/EhpPagination";
function SiteCreate(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const setRecoilTree = useSetRecoilState(curAdminTreeState);
    const setReloadPages = useSetRecoilState(reLoadPage);
    const langIds = useRecoilValue(langId);
    //props
    const { setWorkMode, handleOpenPop } = props;
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    //
    const [companyzones, setCompanyzones] = useState([]);
    const [searchTxt, setSearchTxt] = useState("");
    const [search, setSearch] = useState("");
    // 페이지
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    useEffect(() => {
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchTxt: searchTxt, setSearchTxt: setSearchTxt, setSearch: setSearch }));
    }, [searchTxt]);
    // 기본 주소
    let appPath = `?page=${pageInfo.number}&size=${pageInfo.size}`;
    if (search.length > 0) {
        appPath = appPath + `&search=${search}`;
    }
    // 사업장 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/companyzones${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setCompanyzones(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
            }
        }
    }, [data, isMobile, langIds]);
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        var schDiv = document.getElementById("mcheck_searchinput");
        var isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            handleCurPage(0);
            setSearch(searchTxt);
        }
        else {
            setSearchTxt("");
            CUTIL.jsopen_m_Popup(e);
        }
    }
    function ZoneAdd(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/product/usertree`,
                appQuery: {
                    product: "zone",
                    productName: item.zoneName,
                    productParentId: item.companyId,
                    approval: 1,
                    isontree: true,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReloadPages(true);
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: CONST.POP_RELOAD, type: CONST.TYPE_NONE, divTag: t("라벨.사업장을등록요청완료했습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilTree({
                        company: { companyId: item.companyId, companyName: item.companyId },
                        zone: { zoneId: data.body.productId, zoneName: data.body.productName },
                        subZone: { subZoneId: "", subZoneName: "" },
                        room: { roomId: "", roomName: "" },
                    });
                    setWorkMode("READ");
                    setReloadPages(false);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    return (_jsx(_Fragment, { children: _jsx("section", Object.assign({ className: "content wcal-296" }, { children: _jsxs("article", Object.assign({ className: "box" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: _jsx("div", Object.assign({ className: "flex-inline gap-14 m-none" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: t("라벨.사업장추가") })) })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("div", Object.assign({ className: "searcharea" }, { children: [_jsx("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: _jsxs("div", Object.assign({ className: "input__direct" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), value: searchTxt, onChange: (e) => setSearchTxt(e.target.value), onKeyDown: (e) => searchEnter(e) }), searchTxt.length > 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchTxt("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray js-open-m", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })) })) })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85,\uC0C1\uC138 \uC8FC\uC18C, \uCD94\uAC00\uD558\uAE30 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "sm-none" }, { children: [_jsx("col", { style: { width: "4%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "110px" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "m-none w4p" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.회사명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.사업장명") }) })), _jsx("th", Object.assign({ scope: "col", className: "sm-none" }, { children: _jsx("span", { children: t("라벨.상세주소") }) })), _jsx("th", Object.assign({ scope: "col", className: "w100" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.추가하기") })) }))] }) }), _jsx("tbody", { children: companyzones.length > 0 &&
                                                companyzones.map((item, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "m-none" }, { children: idx + 1 })), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.companyName })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.zoneName })) }), _jsx("td", Object.assign({ className: "sm-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: item.zoneAddress })) })), _jsx("td", Object.assign({ className: "w100" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-no", onClick: (e) => ZoneAdd(item) }, { children: _jsx("span", { children: t("라벨.추가하기") }) })) }))] }, "companyzones_" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "SITE", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })) })) }));
}
export default SiteCreate;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function SearchPop(props) {
    const t = useTrans();
    // props
    const { searchTxt, setSearchTxt, setSearch } = props;
    // 모바일 취소 이벤트 및 초기화
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
        setSearchTxt("");
        setSearch("");
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            handleGoSearch(e);
        }
    }
    function handleGoSearch(e) {
        setSearch(searchTxt);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "form__input mb-0" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.검색어입력"), value: searchTxt, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchTxt(e.target.value) }), searchTxt && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: (e) => setSearchTxt("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => handleGoSearch(e) }, { children: _jsx("span", { children: t("라벨.적용") }) }))] }))] }));
}
